import { render } from "./MessagesHistory.vue?vue&type=template&id=4aa45c59"
import script from "./MessagesHistory.vue?vue&type=script&lang=js"
export * from "./MessagesHistory.vue?vue&type=script&lang=js"

import "./MessagesHistory.vue?vue&type=style&index=0&id=4aa45c59&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__